import { useState, useCallback } from "react";
import { httpsCallable } from "@firebase/functions";
import { functions } from "../../../../firebaseConfig";
import { HttpsCallableResult } from "@firebase/functions-types";

type LeaderBoard = {
  rank: number;
  userId: string;
  points: number;
  completedLoans: number;
};

export const useGetLeaderboard = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [leaderboard, setLeaderboard] = useState<LeaderBoard[] | null>(null);
  const [isLastLeaderboardPage, setIsLastLeaderboardPage] =
    useState<boolean>(false);

  const fetchLeaderboardData = httpsCallable(functions, "fetchLeaderboard");

  const fetchLeaderboard = useCallback(
    async (pageSize: number, startAfter: number, refresh: boolean) => {
      setLoading(true);
      try {
        const response: HttpsCallableResult = await fetchLeaderboardData({
          pageSize,
          startAfter,
        });

        setIsLastLeaderboardPage(response.data.lastPage);
        if (refresh) {
          setLeaderboard(response.data.leaderboardData);
        } else {
          setLeaderboard((prevLeaderboard) => [
            ...(prevLeaderboard || []),
            ...response.data.leaderboardData,
          ]);
        }
        setError(null);
      } catch (err) {
        console.log(err);
        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unexpected error occurred.");
        }
        setIsLastLeaderboardPage(false);
        setLeaderboard(null);
      } finally {
        setLoading(false);
      }
    },
    [fetchLeaderboardData],
  );

  return {
    fetchLeaderboard,
    isLastLeaderboardPage: isLastLeaderboardPage,
    loadingLeaderboard: loading,
    leaderboardData: leaderboard,
    leaderboardError: error,
  };
};
